import localDB from "./localDB";
let GLOBAL = require('./globals');

const UserData = {
  setup(data, res) {
    fetch(`${GLOBAL.BASE_URL}api/account/user-setup`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': localDB.sessionToken()
      },
      body: JSON.stringify(data)
    }).then((response) => response.json()).then((responseData) => {
      res(responseData);
    }).catch((err) => {
      res({update: false})
    });
  },
};

export default UserData;



// WEBPACK FOOTER //
// ./src/data/UserData.js